export const COLLATERAL_OBJECTS_ERROR_NO_ITEMS = 'Er zijn geen registergoederen gevonden.';
export const COLLATERAL_OBJECTS_API = 'collateral-objects';
